import { render, staticRenderFns } from "./ChargesTable.vue?vue&type=template&id=89bf3e4a&scoped=true"
import script from "./ChargesTable.vue?vue&type=script&lang=js"
export * from "./ChargesTable.vue?vue&type=script&lang=js"
import style0 from "./ChargesTable.vue?vue&type=style&index=0&id=89bf3e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf3e4a",
  null
  
)

export default component.exports